import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Api from '../../../api/Api.js';
import ReactSelect from '../../../components/Select/ReactSelect';

import { connect } from 'react-redux';
import EmailEndpoints from '../../../api/EmailEndpoints';
import { SET_EMAIL_LIST } from '../../../redux/types';
import { store } from '../../../redux/store';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class PickEmailDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedEmail: { label: 'None', value: '' },
            loading: true
        }
    }

    componentDidMount() {
        Api.get(EmailEndpoints.list)
        .then(({ data }) => {
            store.dispatch({ type: SET_EMAIL_LIST, payload: data })
            this.setState({ loading: false });
        })
        .catch((e) => console.error(e));
    }

    render() {
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Pick Email</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <ReactSelect
                        options={
                            this.props.emails && this.props.emails.length > 0 ?
                                [{ label: 'None', value: '' }].concat(this.props.emails.filter(e => !this.props.exclude.some(x => x === e.emailaddress)).map(e => ({ label: e.emailaddress, value: e.id })))
                                :
                                [{ label: 'None', value: '' }]
                        }
                        onChange={(value) => this.setState({ selectedEmail: value })}
                        placeholder="Please Select an Email..."
                        value={this.state.selectedEmail}
                        isSearchable
                        isLoading={this.state.loading}
                        isDisabled={this.state.loading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.state.selectedEmail.value && this.props.submit && this.props.submit(this.state.selectedEmail.value)}
                                color="rose"
                                round
                            >
                                Continue
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = ({ emails }) => {
    return {
        emails: emails.list
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(connect(mapStateToProps)(PickEmailDialog));